const preloaderStyle = require('./preloader.css');

function defaultAppend(container: HTMLElement, loader: SVGElement) {
  container.appendChild(loader);
}

export interface ILoaderConfig {
  size: number;
  color?: string;
  style?: string;
  append?(container: HTMLElement, loader: SVGElement): void;
}

export function appendPreloader(container: HTMLElement, config: ILoaderConfig) {
  const div = document.createElement('div');
  // tslint:disable-next-line:max-line-length
  div.innerHTML = `<svg class="${preloaderStyle['serpFastBundlePreloader']}" style="width:${config.size}px;height:${
    config.size
  }px;${config.style ||
    ''}" viewBox="0 0 40 40"><defs><linearGradient id="preloader-gradient" gradientUnits="userSpaceOnUse" y1="30" x2="40" y2="30"><stop offset="0" stop-color="${config.color ||
    '#0076eb'}"></stop><stop offset="1" stop-color="#fff" stop-opacity="0"></stop></linearGradient></defs><path fill="url(#preloader-gradient)" d="M20,35c-8.3,0-15-6.7-15-15H0c0,11,9,20,20,20c11,0,20-9,20-20h-5C35,28.3,28.3,35,20,35z"></path></svg>`;
  const svg = div.children[0] as SVGElement;

  if (config.append) {
    config.append(container, svg);
  } else {
    defaultAppend(container, svg);
  }

  return () => {
    container.removeChild(svg);
  };
}
